import axios from 'axios'
import { CreateCorporateResponse, CorporateData } from '../../types/corporate'

export const createCorporate = async (
  data: CorporateData
): Promise<CreateCorporateResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const formData = new FormData()
    formData.append('project_id', data.project_id.toString())

    if (data.workload) {
      formData.append('workload', data.workload)
    }

    if (data.departments) {
      formData.append('departments', JSON.stringify(data.departments))
    }

    if (data.goal) {
      formData.append('goal', data.goal)
    }

    if (data.competencies) {
      formData.append('competencies', JSON.stringify(data.competencies))
    }

    if (data.expectedBehaviors) {
      formData.append('expectedBehaviors', data.expectedBehaviors)
    }

    if (data.indicators) {
      formData.append('indicators', JSON.stringify(data.indicators))
    }

    if (data.currentGoal) {
      formData.append('currentGoal', data.currentGoal)
    }

    if (data.structure) {
      formData.append('structure', JSON.stringify(data.structure))
    }

    const response = await axios.post(
      `${backendUrl}/n8n/mavis/corporate`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return (response.data as unknown) as CreateCorporateResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
